import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSwiggy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M12.878 5.928a.297.297 0 0 1 .314.335l.003.276c.001.593-.002 1.185.002 1.777.004.434.08.517.5.57a15 15 0 0 0 3.148-.046 5 5 0 0 0 1.573-.374.507.507 0 0 0 .344-.603 6.83 6.83 0 0 0-5.343-5.71 6.6 6.6 0 0 0-3.648.242 6.7 6.7 0 0 0-2.694 1.752A6.27 6.27 0 0 0 5.23 8.432a11.2 11.2 0 0 0 1.526 5.517 1.34 1.34 0 0 0 1.33.748c.653-.016 1.307-.004 1.96-.004v-.003h2.084c.25 0 .447.06.445.372-.005.726 0 1.45-.003 2.176-.002.22-.064.432-.326.434-.264.002-.327-.209-.33-.43-.005-.347 0-.694 0-1.041 0-.451-.073-.557-.523-.64a7.7 7.7 0 0 0-2.348-.02 2.6 2.6 0 0 0-.8.196c-.212.1-.296.245-.193.467.107.231.206.467.333.688a44 44 0 0 0 3.426 4.956c.154.199.273.203.431.01.349-.426.715-.839 1.06-1.268a34 34 0 0 0 3.577-5.26 14.2 14.2 0 0 0 1.494-3.871 1.203 1.203 0 0 0-1.012-1.635 7 7 0 0 0-1.67-.162c-.909-.006-1.818-.003-2.727-.002-.245 0-.427-.07-.427-.358 0-1.01-.002-2.022.002-3.033 0-.216.104-.349.339-.34" />
  </svg>
);
export default SvgSwiggy;
